import SectionContainer from "../SectionContainer";
import styles from "./RoomTypeSection.module.scss";
import useRoomTypeContext from "./context/useRoomTypeContext";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import { getCustomData, getRoomTypeTabData } from "./utils";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";
import { Suspense, useState } from "react";
import CustomAccordionItemWithShimmer from "./components/CustomAccordianItemWithShimmer";
import PropertyFiltersSection from "./components/PropertyFiltersSection";
import RoomTypeSection from ".";
//

const RoomTypeSectionDynamicDesktop = ({ isDesktop = true }) => {
  const {
    roomTypes: { data, count = 0 },
    isLoading,
    showPrevDataWithoutShimmer,
  } = useRoomTypeContext();
  const { t } = useTranslationHook();
  const [activeTab, setActiveTab] = useState("all");
  const tabdata = getRoomTypeTabData(data);
  const customData = getCustomData(tabdata, activeTab);

  const Loading = () => (
    <SectionContainer
      title={t("propertypage.roomtypesectiondynamic.roomtypetitle")}
      count={count}
      id="room_type"
      className={formatClassNames(styles.container, isDesktop && styles.desktop)}
      isDesktop={isDesktop}
      dataTestId="property_page_room_types_section"
      headingLevel={2}
    >
      <PropertyFiltersSection
        tabdata={tabdata}
        setActiveTab={(val: any) => setActiveTab(val)}
        activeTab={activeTab}
        isDesktop={isDesktop}
      />
      {customData?.map((item: any, index: number) => (
        <CustomAccordionItemWithShimmer
          key={index}
          {...item}
          isDesktop={isDesktop}
          activeTab={activeTab}
          isLastItem={index === data.length - 1}
          isPlusCategories={false}
          isLoading={isLoading}
        />
      ))}
    </SectionContainer>
  );

  if (__CLIENT__ && !isLoading && !showPrevDataWithoutShimmer) {
    return (
      <Suspense fallback={<Loading />}>
        <RoomTypeSection isDesktop />
      </Suspense>
    );
  }

  return <Loading />;
};

export default wrapperHOC(RoomTypeSectionDynamicDesktop, {
  componentName: "RoomTypeSectionDynamicDesktop-PropertyPage",
  showForChina: true,
});
